module.exports = __webpack_public_path__ + "static/img/logobg.b979e44.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logobg.png
// module id = 4PZY
// module chunks = 118